export enum requestSlotTypes {
  singleSlot = 'SINGLE_SLOT',
  tourSlot = 'TOUR_SLOT',
}
